// Home's timelines preview (DC-56 merged into DC-20: "`tev` is the compact form for the Home widget (≤ 8 rows)"; CR-094
// "Requisition timeline: request through approval/posting/intake/panel/offer/filled/hold/cancel/reopen/archive."):
// S13 sends the requisitions whose timelines the reader may read (at most eight); the widget draws one of them at a time
// through S18's TimelineList in its compact form, eight rows at most, with actor, time, source and the artifact chips the
// reader may open (a chip the reader could not open is absent). A choice of requisition switches the list; the
// requisition's own link opens its page.

import { useState } from "react";
import { Row, RowName, Select, Stack, Widget } from "@/mc";
import { HISTORY_LABELS } from "@/mc/g5/labels";
import { NAV_ITEM_LABELS } from "@/mc/labels";
import { TimelineList } from "@/views/b10/timeline/TimelineList";
import type { HomeWidgetView } from "./host";
import { DASH, seatsOf, timelinesOf, type TimelinesData } from "./api";
import { hsKey } from "@/views/b10/lib/hsKey";

/** DC-20's compact form holds at most eight rows. */
export const PREVIEW_ROWS = 8;

export function TimelinesBody({ data }: { data: TimelinesData }) {
  const rows = data.rows.slice(0, PREVIEW_ROWS);
  const [chosen, choose] = useState(rows[0]?.requisition_id ?? "");
  const current = rows.find((row) => row.requisition_id === chosen) ?? rows[0];
  if (!current) return null;
  return (
    <Stack gap={10}>
      {rows.length > 1 ? (
        <Select
          sm
          required
          aria-label={NAV_ITEM_LABELS.requisitions}
          options={rows.map((row) => ({ value: row.requisition_id, label: row.title }))}
          value={current.requisition_id}
          onChange={(value) => choose(value)}
          
        />
      ) : null}
      <Row cols={1} href={current.route || undefined} hs={hsKey("dash.timelines.req", current.requisition_id)}>
        <RowName name={current.title} sub={current.requisition_id} />
      </Row>
      <TimelineList key={current.requisition_id} subject="requisition" id={current.requisition_id} limit={PREVIEW_ROWS} compact hsPrefix="dash.timelines" />
    </Stack>
  );
}

// D-25: drawn even with nothing in it, the Card's empty slot holding B10's DASH (as ActiveRequisitions.tsx says).
/** Widget `timelines` (S13 → S16, frozen). */
export const TimelinesPreview: HomeWidgetView = ({ widgetKey, data }) => {
  const timelines = timelinesOf(data);
  const none = timelines.rows.length === 0;
  return (
    <Widget id={widgetKey} kind="timelines" roles={seatsOf(widgetKey)} title={HISTORY_LABELS.requisitionTimeline} empty={none ? DASH : undefined}>
      {none ? null : <TimelinesBody data={timelines} />}
    </Widget>
  );
};
